import { render, staticRenderFns } from "./monthmanchargecost.vue?vue&type=template&id=c67f4afa&scoped=true&"
import script from "./monthmanchargecost.vue?vue&type=script&lang=js&"
export * from "./monthmanchargecost.vue?vue&type=script&lang=js&"
import style0 from "./monthmanchargecost.vue?vue&type=style&index=0&id=c67f4afa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67f4afa",
  null
  
)

export default component.exports